import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCocktail: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCocktail"><Path d="M0.941406 3L11.25 13.325V20.5H7V22H17V20.5H12.75V13.325L23.0587 3H0.941406Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCocktail;
